import { render } from "./AddressDetails.vue?vue&type=template&id=783542f2"
import script from "./AddressDetails.vue?vue&type=script&lang=js"
export * from "./AddressDetails.vue?vue&type=script&lang=js"

import exportComponent from "/Users/chrismains/Sites/fixmycar/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__